<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-flex flex-column" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header">{{widgetData?.title}}</div>
    <div class="d-flex align-items-center">
        <div class="flex1">
            <div><img src="../../../../assets/images/avatar.svg" alt="" class="img-fluid mxh60">KD2475703</div>
            <div class="d-flex">
                <div class="d-flex flex-column">
                    <div>{{driverData?.name}}</div>
                    <div class="ft-12">{{driverData?.phone}}</div>
                </div>
            </div>
        </div>
        <div>
            <div class="d-flex justify-content-center flex-column">
                <div class="d-flex align-items-center">
                    <div class="starlogo"><img src="../../../../assets/images/rewardpoint.svg" alt="rewardimage"
                            class="img-fluid  wh40"></div>
                    <div class="vehicle-score-value d-flex">{{driverData?.rating}}</div>
                </div>
                <div class="vehicle-rating">Very good</div>
            </div>
        </div>
    </div>
</div>
<p *ngIf="isloader || isError">No Data Available</p>